import React, { useContext } from 'react';
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmStates } from '../../root/tcsm-model';
import { Filter, SearchAppContext } from '../models/search-models';
import { resetSearchByApp, setFilterPills } from '../slices/backend-search-slice';
import { SearchProps } from '../../pages/arc/models/arc-epi-props';
import { generateFilterPills, getFilterKeyLabelMap } from '../backend-search-helpers';
import { ButtonWrapper } from '../../global/components/layout/button-wrapper';
import { buttonStyles } from '../../global/constants/theme/styles/components/buttonstyles';



export function FilterActionButtons() {
    const buttonClasses = buttonStyles();
    const app = useContext(SearchAppContext);
    const dispatch = useDispatch();
    const searchSettings = useSelector<TcsmStates, SearchProps>(state => state?.epiProps?.searchSettingsState?.epiContent);
    const selectedFilters = useSelector<TcsmStates, Filter[]>(state => state?.backendSearchStates[app].seletedFilters);
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    };

    const onApplyFilter = () => {
        dispatch(setFilterPills(generateFilterPills(selectedFilters, getFilterKeyLabelMap(searchSettings)), app));
        scrollToTop();
        
    };
    const onResetFilter = () => {
        dispatch(resetSearchByApp(app));
        scrollToTop();
    };
    return (
        <Grid item xs={12}>
            <ButtonWrapper flexEnd>
                <button className={buttonClasses.primaryButton} type='button' onClick={onApplyFilter} >{searchSettings?.applyFilterText}</button>
                <button className={buttonClasses.tertiaryButton} type='button' onClick={onResetFilter} >{searchSettings?.resetFilterText}</button>
            </ButtonWrapper>
        </Grid>
    );
}


